<template>
  <footer class="main-footer">
    &copy; ХАКАТОНЫ.РУС
  </footer>
</template>